// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1NEj9","footer":"ModalInfo_footer__1Tg0y"};